//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { AuditLogModel } from '@/modules/audit-log/audit-log-model';
import { mapGetters, mapActions } from 'vuex';

const { fields } = AuditLogModel;

export default {
  name: 'app-audit-log-table',

  computed: {
    ...mapGetters({
      rows: 'auditLog/rows',
      count: 'auditLog/count',
      loading: 'auditLog/loading',
      pagination: 'auditLog/pagination',
      isMobile: 'layout/isMobile',
      paginationLayout: 'layout/paginationLayout',
    }),

    fields() {
      return fields;
    },
  },

  methods: {
    ...mapActions({
      doChangeSort: 'auditLog/doChangeSort',
      doChangePaginationCurrentPage:
        'auditLog/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'auditLog/doChangePaginationPageSize',
    }),

    presenter(row, fieldName) {
      return AuditLogModel.presenter(row, fieldName);
    },

    view(values) {
      const data = JSON.stringify(values, null, 2);
      const jsonWindow = window.open(
        '',
        '_blank',
        'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400',
      );
      jsonWindow.document.write(`<pre>${data}</pre>`);
    },
  },
};
